import React from "react";

import ReactDraggable from "react-draggable";
import {
    Button,
    ClickAwayListener,
    OutlinedInput,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

import { StrategyDialogContent, StrategyDialogDiv } from "../CommonStyles";
import { CloseGrayIcon } from "../../../CommonUI/Icon/CloseGrayIcon";
import {
    FlowStepOutputInstructions,
    FlowStepOutputInstructionType,
} from "../../../rule-engine-core/Flow/Structure/FlowStepOutputInstructions";
import { BaseStepStrategy } from "../BaseStepStrategy";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";

export class RenderStepStrategy extends BaseStepStrategy {
    render() {
        const { editContext } = this.props;

        if (!editContext.selectedStepStrategy) {
            return <></>;
        }
        let { step, position } = editContext.selectedStepStrategy;
        let paths = step.getOutcomeInstructions() || [];
        if (paths.length === 0) {
            return <></>;
        }
        return (
            <ClickAwayListener onClickAway={this.onUnselectStepStrategyConnect}>
                <ReactDraggable
                    handle=".StrategyDialog-title"
                    defaultPosition={position}
                >
                    <StrategyDialogDiv data-testid="select-strategy-dialog">
                        <StrategyDialogContent onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}>
                            <Button
                                onClick={this.onUnselectStepStrategyConnect}
                                className={"StrategyDialog-close"}
                            >
                                <CloseGrayIcon />
                            </Button>
                            <Typography className={"StrategyDialog-title"}>{step?.name} Paths</Typography>
                            <TableContainer className="StrategyDialog-table">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Path</TableCell>
                                            <TableCell>Strategies</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paths.map((instruction, idx) => (
                                            <ObserveState
                                                listenTo={instruction}
                                                control={() => {
                                                    return (
                                                        <TableRow key={idx}>
                                                            <TableCell>{instruction.pathName}</TableCell>
                                                            <TableCell
                                                                align={idx > 0 ? "right" : "left"}
                                                                style={{ width: 196 }}
                                                            >
                                                                {idx > 0 ? (
                                                                    <>
                                                                        <Select
                                                                            fullWidth
                                                                            className={`StrategyDialog-select ${
                                                                                instruction.strategy ===
                                                                                    FlowStepOutputInstructionType.THROW_EXCEPTION &&
                                                                                "StrategyDialog-select-error"
                                                                            }`}
                                                                            variant="outlined"
                                                                            native
                                                                            value={instruction.strategy}
                                                                            onChange={(event) => {
                                                                                instruction.strategy = event.target
                                                                                    .value as FlowStepOutputInstructionType;
                                                                            }}
                                                                            data-testid={`select-strategy-dialog_${instruction.pathName}`}
                                                                        >
                                                                            <option
                                                                                value={
                                                                                    FlowStepOutputInstructionType.CONTINUE
                                                                                }
                                                                            >
                                                                                Continue
                                                                            </option>
                                                                            <option
                                                                                value={
                                                                                    FlowStepOutputInstructionType.THROW_EXCEPTION
                                                                                }
                                                                            >
                                                                                End in error
                                                                            </option>
                                                                            <option
                                                                                value={
                                                                                    FlowStepOutputInstructionType.END_FLOW
                                                                                }
                                                                            >
                                                                                End Flow
                                                                            </option>
                                                                            <option
                                                                                value={
                                                                                    FlowStepOutputInstructionType.BRANCH
                                                                                }
                                                                            >
                                                                                Link to new sequence
                                                                            </option>
                                                                        </Select>
                                                                        {instruction.strategy ===
                                                                            FlowStepOutputInstructionType.THROW_EXCEPTION && (
                                                                            <ObserveState
                                                                                listenTo={instruction}
                                                                                properties={[
                                                                                    FlowStepOutputInstructions.ERROR_MESSAGE,
                                                                                ]}
                                                                                control={() => (
                                                                                    <OutlinedInput
                                                                                        className="Strategy-error"
                                                                                        value={instruction.errorMessage}
                                                                                        data-testid={`select-strategy-dialog_${instruction.pathName}-set-error`}
                                                                                        onChange={(
                                                                                            e: React.ChangeEvent<HTMLInputElement>,
                                                                                        ) => {
                                                                                            instruction.errorMessage =
                                                                                                e.target.value;
                                                                                        }}
                                                                                        placeholder="Error Message"
                                                                                    />
                                                                                )}
                                                                            />
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <label className="StrategyDialog-default__text">
                                                                        Continue Next Step
                                                                    </label>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                }}
                                            />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </StrategyDialogContent>
                    </StrategyDialogDiv>
                </ReactDraggable>
            </ClickAwayListener>
        );
    }
}
